import { CodedError } from '../../CodedError';
import { errorCodes } from '../../constants/errorCodes';

export class EssensysBookingNegativeAmountError extends CodedError {
  static get errorName() {
    return errorCodes.essensysBookingNegativeAmountError.code;
  }

  constructor(message: string = errorCodes.essensysBookingNegativeAmountError.message) {
    super(message);
    this.code = errorCodes.essensysBookingNegativeAmountError.code;
    this.message = `${message} ${errorCodes.essensysBookingNegativeAmountError.code}`;
    this.name = errorCodes.essensysBookingNegativeAmountError.name;
  }
}
